import { createIcon } from '@chakra-ui/react/icon'

const TextJustifyIcon = createIcon({
  displayName: 'TextJustifyIcon',
  viewBox: '0 0 16 16',
  path: [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 12.5a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z"
    />,
  ],
})

export default TextJustifyIcon
